"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var IconCheck = function IconCheck(props) {
  return (0, _themeUi.jsx)("svg", props, (0, _themeUi.jsx)("path", {
    d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
  }));
};

IconCheck.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
};

var variants = function variants(active) {
  return {
    primary: _extends({}, active && {
      bg: 'primaryLight',
      color: 'textWhite',
      ':active': {
        bg: 'primary'
      }
    }),
    secondary: _extends({}, active && {
      bg: 'secondary',
      color: 'text',
      ':active': {
        bg: 'secondaryDark'
      }
    }),
    secondaryLight: _extends({}, active && {
      bg: 'white',
      color: 'text',
      ':active': {
        bg: 'secondayLight'
      }
    })
  };
};

var ChipFilter = function ChipFilter(_ref) {
  var active = _ref.active,
      variant = _ref.variant,
      children = _ref.children,
      disabled = _ref.disabled,
      props = _objectWithoutPropertiesLoose(_ref, ["active", "variant", "children", "disabled"]);

  return (0, _themeUi.jsx)("button", _extends({}, props, {
    type: "button",
    disabled: disabled,
    sx: _extends({
      display: 'inline-flex',
      alignItems: 'center',
      cursor: disabled ? 'default' : 'pointer',
      borderRadius: 'xLarge',
      py: 2,
      pr: 3,
      pl: active ? 2 : 3,
      fontFamily: 'body',
      fontSize: 1,
      lineHeight: 'tight',
      letterSpacing: 'normal',
      outline: 'none',
      borderWidth: 'thin',
      borderStyle: 'solid',
      whiteSpace: 'nowrap',
      bg: 'neutral.0',
      color: 'primary',
      ':hover': {
        bg: 'neutral.1'
      },
      ':active': {
        bg: 'neutral.2'
      }
    }, active && {
      borderStyle: 'none',
      boxShadow: 0,
      ':hover': {
        boxShadow: 3
      }
    }, variants(active)[variant], {
      ':disabled': {
        boxShadow: 'none',
        color: 'textDisabled',
        bg: 'blackDisabled'
      },
      transition: function transition(theme) {
        return "box-shadow 200ms " + theme.easing.quickToSlow;
      }
    })
  }), (0, _themeUi.jsx)("span", {
    sx: {
      display: 'flex',
      position: 'relative',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, active && (0, _themeUi.jsx)(_Icon["default"], {
    icon: IconCheck,
    size: 1,
    sx: {
      color: variant === 'primary' ? 'textWhiteMediumEmphasis' : 'textMediumEmphasis',
      mr: 2
    }
  }), (0, _themeUi.jsx)("span", {
    sx: {
      flexGrow: 1
    }
  }, children)));
};

ChipFilter.propTypes = {
  active: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  variant: _propTypes["default"].oneOf(['primary', 'secondary']),
  children: _propTypes["default"].node
};
ChipFilter.defaultProps = {
  active: false,
  disabled: false,
  variant: 'secondary'
};
var _default = ChipFilter;
exports["default"] = _default;